import { useActiveSessionQuery } from 'modules/sessions';
import { useSessionType } from 'modules/sessions/hooks/useSessionType';
import React, { useMemo } from 'react';
import { capitalizeFirstLetter } from 'utils/Util';

const TextEnviroment = ( { isAdmin } ) => {
  const { data } = useActiveSessionQuery();

  const { isEnterprise, isNow, isStudio } = useSessionType(
    data && data.distributionType,
  );

  const distributionName = useMemo( () => {
    if ( isAdmin ) return 'Admin';
    if ( isNow ) return 'Now';
    if ( isStudio ) return 'Studio';
    if ( isEnterprise ) return 'Advanced';
    return '';
  }, [isEnterprise, isNow, isStudio, isAdmin] );

  return <>{distributionName && capitalizeFirstLetter( distributionName )}</>;
};

export default TextEnviroment;
